"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerInquirySupportTicketStatus = void 0;
/** Lifecycle status of a partner support ticket. */
var PartnerInquirySupportTicketStatus;
(function (PartnerInquirySupportTicketStatus) {
    PartnerInquirySupportTicketStatus["OPEN"] = "OPEN";
    PartnerInquirySupportTicketStatus["COMPLETE"] = "COMPLETE";
})(PartnerInquirySupportTicketStatus || (exports.PartnerInquirySupportTicketStatus = PartnerInquirySupportTicketStatus = {}));
